import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/index/8.png'
import _imports_1 from '@/assets/index/9.png'
import _imports_2 from '@/assets/index/10.png'
import _imports_3 from '@/assets/index/11.png'
import _imports_4 from '@/assets/index/12.png'


const _withScopeId = n => (_pushScopeId("data-v-f69a515c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row10 mt-12 h-40 relative cc\" data-v-f69a515c><div class=\"flex cc absolute bottom-8\" data-v-f69a515c><img class=\"mr-2 md:mr-5\" src=\"" + _imports_0 + "\" alt=\"\" data-v-f69a515c><img class=\"mr-2 md:mr-5\" src=\"" + _imports_1 + "\" alt=\"\" data-v-f69a515c><img class=\"mr-2 md:mr-5\" src=\"" + _imports_2 + "\" alt=\"\" data-v-f69a515c><img class=\"mr-2 md:mr-5\" src=\"" + _imports_3 + "\" alt=\"\" data-v-f69a515c><img class=\"\" src=\"" + _imports_4 + "\" alt=\"\" data-v-f69a515c></div></div><div class=\"row11\" data-v-f69a515c><p class=\"cc h-12\" data-v-f69a515c> Copyright © 2017 . All rights moon. </p></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}